//Get ABTasty visitor ID and all tests/variations they were exposed to.
export function getABTastyData() {
  try {
    // @ts-ignore - ABTasty is injected by external script
    const ABTasty = typeof window !== 'undefined' ? window.ABTasty : undefined

    if (!ABTasty) {
      return { visitorId: '', tests: [] }
    }

    // Get visitor ID
    const visitorId =
      ABTasty.visitor?.id || ABTasty.api?.v1?.getValue?.('visitorId') || ''

    // getCampaignHistory() returns campaigns visitor has seen
    // Format: { campaignId: variationId, ... }
    const campaignHistory = ABTasty.getCampaignHistory?.() || {}

    // results contains detailed info but only for current page tests
    const results = ABTasty.results || {}

    const tests = Object.entries(campaignHistory).map(
      ([testId, variationId]) => {
        // get variation name and test name from results
        const testDetails = results[testId]

        return {
          testId,
          testName: testDetails?.name || testDetails?.testName || '',
          variationId: String(variationId),
          variationName: testDetails?.variationName || '',
        }
      },
    )

    return { visitorId, tests }
  } catch (error) {
    console.warn('[ABTasty] Failed to get ABTasty data:', error)
    return { visitorId: '', tests: [] }
  }
}

/**
 * Format as JSON string for form submission.
 * @returns {string}
 */
export function getABTastyDataString() {
  const { visitorId, tests } = getABTastyData()

  if (!visitorId && tests.length === 0) {
    return ''
  }

  return JSON.stringify({ visitorId, tests })
}
